import { css, cx } from "@emotion/css";
import type { TextInput } from "@octopusdeploy/design-system-components";
import { MagnifyingGlassIcon } from "@octopusdeploy/design-system-icons";
import { themeTokens } from "@octopusdeploy/design-system-tokens";
import { forwardRef, useImperativeHandle, useRef } from "react";
import { DebounceValue } from "../../utils/DebounceValue";
import { TextWithLabel as Text } from "../Form/Text";
export interface FilterSearchBoxProps {
    placeholder?: string;
    onChange: (newValue: string) => void;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onKeyDown?: (keyEvent: any) => void;
    value?: string;
    autoFocus?: boolean;
    containerClassName?: string;
    inputClassName?: string;
    iconColor?: string;
    fullWidth?: boolean;
    error?: string;
}
export interface FilterSearchBoxRef {
    focus(): void;
}
const FilterSearchBoxInternal = forwardRef<FilterSearchBoxRef, FilterSearchBoxProps>(function FilterSearchBoxInternal(props, ref) {
    const textInputRef = useRef<TextInput | null>(null);
    useImperativeHandle(ref, () => ({
        focus: () => textInputRef.current?.focus(),
    }));
    const searchIconColor = props.iconColor ? props.iconColor : themeTokens.color.text.secondary;
    return (<div className={cx(props.containerClassName, filterFieldStyles, props.fullWidth && filterFieldFullWidthStyles)}>
            <Text textInputRef={(el) => {
            textInputRef.current = el;
        }} type="search" placeholder={props.placeholder} value={props.value ?? ""} onChange={(value) => props.onChange(value)} autoFocus={props.autoFocus} onKeyDown={props.onKeyDown} className={cx(props.inputClassName, props.fullWidth ? filterTextBoxFullWidthStyles : filterTextBoxStandardWidthStyles)} error={props.error ?? ""} accessibleName={props.placeholder}/>
            <span className={searchIconStyles} aria-hidden="true">
                <MagnifyingGlassIcon size={20} color={searchIconColor}/>
            </span>
        </div>);
});
export const FilterSearchBox = DebounceValue<FilterSearchBoxProps, string>(FilterSearchBoxInternal);
const filterFieldStyles = css({
    position: "relative",
    display: "inline-block",
    // Clears the 'X' from Chrome
    "input[type=\"search\"]::-webkit-search-cancel-button": {
        appearance: "none",
    },
});
const filterFieldFullWidthStyles = css({
    width: "100%",
});
const filterTextBoxStandardWidthStyles = css({
    width: "15.6rem !important",
});
const filterTextBoxFullWidthStyles = css({
    width: "100% !important",
});
const searchIconStyles = css({
    position: "absolute",
    right: "0",
    top: "1.25rem",
});
